import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { sendGAEvent } from '../../../../common/utilsAnalytics';
import { logo, logo_extra } from '../../../../generated/resources';
import { Model } from '../../../../services/model';

@Component({
  selector: 'sign-up',
  templateUrl: 'sign-up.pug',
  styleUrls: ['sign-up.scss'],
})
export class SignUp implements OnInit {
  readonly logo = logo;
  readonly logoSignup = logo_extra;
  @Input() data = { forced: false, isPublicDemoDrawing: false };
  @Output() close = new EventEmitter<void>();

  constructor(private model: Model) {
  }
  get anonName() {
    return this.model.user.name;
  }
  ngOnInit() {
    sendGAEvent('Sign up', 'View', 'popup-modal');
  }
  closeModal() {
    this.close.emit();
  }
}
